var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_933",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9C8.175 9 7.46875 8.70625 6.88125 8.11875C6.29375 7.53125 6 6.825 6 6C6 5.175 6.29375 4.46875 6.88125 3.88125C7.46875 3.29375 8.175 3 9 3C9.825 3 10.5312 3.29375 11.1187 3.88125C11.7062 4.46875 12 5.175 12 6C12 6.825 11.7062 7.53125 11.1187 8.11875C10.5312 8.70625 9.825 9 9 9ZM4.5 15C4.0875 15 3.7345 14.8533 3.441 14.5598C3.147 14.2658 3 13.9125 3 13.5V12.9C3 12.475 3.1095 12.0843 3.3285 11.7278C3.547 11.3718 3.8375 11.1 4.2 10.9125C4.975 10.525 5.7625 10.2343 6.5625 10.0403C7.3625 9.84675 8.175 9.75 9 9.75C9.825 9.75 10.6375 9.84675 11.4375 10.0403C12.2375 10.2343 13.025 10.525 13.8 10.9125C14.1625 11.1 14.453 11.3718 14.6715 11.7278C14.8905 12.0843 15 12.475 15 12.9V13.5C15 13.9125 14.8533 14.2658 14.5598 14.5598C14.2658 14.8533 13.9125 15 13.5 15H4.5Z",
    fill: "#A2A2A2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/user-info.882900e092de297dc418928f389569f7.svg";
export { ForwardRef as ReactComponent };